import DOMPurify from "dompurify";
import type { TCertificateCardProps } from "./types";

export const CertificateCard = ({
  image,
  title,
  description,
}: TCertificateCardProps) => {
  const CertificateCardElement = document.createElement("div");
  CertificateCardElement.className =
    "w-full p-6 flex flex-col items-center gap-12 bg-white";

  CertificateCardElement.innerHTML = DOMPurify.sanitize(/* html */ `
        <img src=${image.src} alt=${image.alt} class="w-45 h-30 object-contain" />

        <div class="flex flex-col gap-2">
            <h3 class="text-xl font-semibold  text-blue-800 text-center lg:text-2xl xl:px-0">
                ${title}
            </h3>

            <p class="text-base  text-gray-800 text-center lg:text-lg">
                ${description}
            </p>
        </div>
    `);

  return CertificateCardElement;
};
